var _rect, _rect2, _rect3, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAiChatSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 37,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 36,
  height: 36,
  rx: 18,
  fill: "#008DE8"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  width: 36,
  height: 36,
  rx: 18,
  fill: "url(#ai_chat_send_svg__a)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 0.5,
  width: 35,
  height: 35,
  rx: 17.5,
  stroke: "#fff",
  strokeOpacity: 0.15
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26.938 18.554a1.25 1.25 0 0 0 0-1.108c-.152-.308-.42-.469-.557-.547a7.017 7.017 0 0 0-.53-.255l-13.986-6.293c-.195-.088-.389-.175-.553-.232-.15-.052-.452-.147-.787-.054a1.25 1.25 0 0 0-.829.748c-.126.323-.063.634-.026.789.04.168.106.37.174.573l1.353 4.078c.11.329.164.493.265.614.09.107.205.19.335.242.147.058.32.058.666.058h6.036a.833.833 0 0 1 0 1.666h-6.02c-.346 0-.518 0-.665.058a.833.833 0 0 0-.334.24c-.101.121-.156.285-.266.612L9.85 23.82a7.234 7.234 0 0 0-.176.573c-.037.155-.102.466.025.79.143.367.45.645.828.75.336.094.639-.002.789-.054.164-.056.358-.144.553-.232l13.982-6.291c.19-.086.38-.172.53-.256.138-.077.405-.239.557-.546Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "ai_chat_send_svg__a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 18 -18 0 18.5 0)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})))));
export default SvgAiChatSend;